import React from 'react';
import { convertCustomTimestamp } from './utils.js';

const MydateTime = ({ record}) => {
    // console.log("myimage ", record)
    const date = convertCustomTimestamp(record);
    return (<div>{date.toLocaleString()}</div>);
}

export default MydateTime;